export default "__VITE_ASSET__BqiTu$BR__"